import {DefaultInteraction} from "./interaction";


export class SwapObject extends DefaultInteraction {

	scene = null

	activeProximity = {}

	constructor(props) {
		super(props);

		this.scene = props.scene
	}


	key() {
		return "swap_object"
	}

	interact(interactionData, metadata, onSuccess, onError) {
		console.log(`Interaction::${this.key()} - Run`, interactionData, metadata)
		this._interact(interactionData, metadata)
		return true
	}

	_interact(interactionData, metadata, onSuccess, onError) {
		let visibleObjects = [];
		for (let alphaID of interactionData.options) {
			const obj = this.scene.get(alphaID)
			if (!obj) {
				continue
			}
			if (obj.visible)
				visibleObjects.push(obj)

			if (interactionData.target_id === alphaID) { //Set our selected object to visible
				obj.visible = true;
				continue
			}

			obj.visible = false; //Set all other objects to invisible
		}
		return visibleObjects
	}

	/**
	 * Reverses the state transition of the swap object
	 * @param alphaID
	 */
	reverseInteract(alphaID) {
		const state = this.activeProximity[alphaID]
		const prevT = this.scene.get(state.target_id)
		if (prevT) prevT.visible = false

		for (let prevO of state.previous)
			if (prevO) prevO.visible = true
	}

	//TODO Handle proximity triggers
	onProximityEnter(interaction, interactable) {
		this.activeProximity[interactable.userData.alphaID] = {target_id: interaction.data.target_id, previous: this._interact(interaction.data, {})}
	}

	onProximityExit(interactable) {
		if (this.activeProximity[interactable.userData.alphaID]) {
			this.reverseInteract(interactable.userData.alphaID)
		}

		delete this.activeProximity[interactable.userData.alphaID]
	}
}